<template>
  <IonPage>
    <IonContent :scroll-y="scrollY">
      <AppPullToRefresh v-if="showPullToRefresh" />
      <slot />
    </IonContent>
  </IonPage>
</template>
<script lang="ts">
import AppPullToRefresh from "@/components/layout/AppPullToRefresh.vue";
import { IonContent, IonPage } from "@ionic/vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "IonPageContainer",
  components: { IonPage, IonContent, AppPullToRefresh },
  props: {
    scrollY: { type: Boolean, default: true },
    showPullToRefresh: { type: Boolean, default: true },
  },
});
</script>
